import moment from 'moment';

import { HemsProperties, ViError } from '../../../projects/client';
import { ExtendedRawConsumptionProperties } from '../_models';
import { FilterType } from './../../+installations/installation/energy-historical-data-modal/energy-filters-header/energy-filters.data';
import { HemsFlowType } from './energy-historical-data.helpers';
import {
  HemsHistoricalData,
  LegendFeature,
  SavedSelectedFeature,
} from './energy-historical-data.model';

export interface EnergyHistoricalDataState {
  chartData: HemsHistoricalData;
  filterType: FilterType;
  date: moment.Moment;
  selectedFeatures: HemsProperties[];
  legendFeatures: LegendFeature[];
  legacyChartData?: ExtendedRawConsumptionProperties[];
  loading: boolean;
  hemsAnalysisSelectedTab: HemsFlowType;
  savedSelectedFeature: SavedSelectedFeature;
  error: ViError;
}

export const selectedChartKey = 'selectedChart';
